module.exports = __webpack_public_path__ + "media/scholarship_winners/mariah-s-5ad7bba9.png";